import { useNavigate } from "react-router-dom";
import PavementContextBasic from "../../components/PavementContext/PavementContextBasic";
import "../PageCommon.css";
import "./PavementContentBasic.css";
import { useEffect } from "react";

const PavementContextPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!localStorage.getItem('token')) {
        navigate('/signin');
        }
    }, [navigate]);

    return (
        <div className="page__container">
            {/* <div className="page__head"></div> */}
            <div className="page__body">
                <PavementContextBasic />
            </div>
        </div>
    );
}

export default PavementContextPage;